import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Drawer } from '@material-ui/core';
import Profile from "./Profile";
import SidebarNav from "./SideBarNav";
import { menuPoint } from "./breakpoints";
import { headerHeight } from "./shareParams";

const useStyles = makeStyles(theme => ({
    drawer: {
        width: 240,
        [theme.breakpoints.up(menuPoint)]: {
            marginTop: headerHeight,
            height: `calc(100% - ${headerHeight}px)`
        }
    },
    root: {
        //backgroundColor: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2)
    },
    divider: {
        margin: theme.spacing(2, 0)
    },
    nav: {
        marginBottom: theme.spacing(2)
    }
}));
export default function Sidebar(props) {
    const { open, variant, onClose, className, pages, ...rest } = props;
    const classes = useStyles();
    return (<Drawer anchor="left" classes={{ paper: classes.drawer }} onClose={onClose} open={open} variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile />
        <Divider className={classes.divider}/>
        <SidebarNav className={classes.nav} pages={pages}/>
      </div>
    </Drawer>);
}
;
